globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import { PersonWithRestworldCupIllustration } from '@restworld/utils-common';
import { Button, Title } from '../../../';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ApplicationSuccessComponent = function ApplicationSuccessComponent(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      buttonFirstTitle = _ref.buttonFirstTitle,
      buttonSecondTitle = _ref.buttonSecondTitle,
      onFirstButtonClick = _ref.onFirstButtonClick,
      onSecondButtonClick = _ref.onSecondButtonClick,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'one' : _ref$variant;
  return /*#__PURE__*/_jsxs(_StyledDiv, {
    children: [/*#__PURE__*/_jsxs(SecondWrapperDiv, {
      isReversed: variant === 'two',
      children: [/*#__PURE__*/_jsx(_StyledDiv2, {
        children: /*#__PURE__*/_jsx(PersonWithRestworldCupIllustration, {
          height: 300,
          width: 240
        })
      }), /*#__PURE__*/_jsxs(_StyledDiv3, {
        children: [/*#__PURE__*/_jsx(Title, {
          content: title,
          fontSize: "extraLarge",
          fontWeight: "semibold",
          twStyle: {
            "lineHeight": "1.688rem"
          }
        }), /*#__PURE__*/_jsx(Title, {
          content: subTitle,
          fontSize: "base",
          fontWeight: "normal",
          twStyle: {
            "lineHeight": "1.5rem"
          },
          textColor: "gray"
        })]
      })]
    }), /*#__PURE__*/_jsxs(_StyledDiv4, {
      children: [/*#__PURE__*/_jsx(Button, {
        title: buttonFirstTitle,
        variant: "normal",
        fullwidth: true,
        onClick: onFirstButtonClick
      }), /*#__PURE__*/_jsx(Button, {
        title: buttonSecondTitle,
        variant: "secondary-outline",
        fullwidth: true,
        onClick: onSecondButtonClick
      })]
    })]
  });
};

var SecondWrapperDiv = /*#__PURE__*/_styled.div.withConfig({
  displayName: "application-success__SecondWrapperDiv",
  componentId: "sc-15gbwld-0"
})(["", " ", ""], {
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "center",
  "gap": "1.25rem",
  "textAlign": "center"
}, function (_ref2) {
  var isReversed = _ref2.isReversed;
  return isReversed ? {
    "flexDirection": "column-reverse"
  } : {
    "flexDirection": "column"
  };
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "application-success___StyledDiv",
  componentId: "sc-15gbwld-1"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "2.5rem"
});

var _StyledDiv2 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "application-success___StyledDiv2",
  componentId: "sc-15gbwld-2"
})({
  "animation": "scale-up-center 1s cubic-bezier(0.390, 0.575, 0.565, 1.000) both"
});

var _StyledDiv3 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "application-success___StyledDiv3",
  componentId: "sc-15gbwld-3"
})({
  "display": "flex",
  "maxWidth": "24rem",
  "flexDirection": "column",
  "gap": "0.5rem"
});

var _StyledDiv4 = /*#__PURE__*/_styled("div").withConfig({
  displayName: "application-success___StyledDiv4",
  componentId: "sc-15gbwld-4"
})({
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.5rem"
});